import { ScreenShareMenuItemsWrapper as ScreenShareMenuItems } from '../../session/controls/ScreenShareControlWrapper';

export function SessionModeControlMenuItemsWrapper() {
  return <ScreenShareMenuItems />;
}
